import React from "react";
import RenderRichContent from "../containers/RenderRichContent";
import WrapRotation from "../primitives/WrapRotation";
import EmojiIcon from "../primitives/EmojiIcon";

const PriceComparison = ({ cardList }) => {
  if (!cardList) return null;

  return (
    <div className="mt-16 mx-auto">
      <h2 className="xl:sr-only text-lg uppercase mb-8">Prices</h2>
      <div className="grid xl:gap-4 xxl:gap-10 xl:grid-cols-3">
        {cardList.map(card => {
          const { title, price, icon, richText, text, link = "" } = card;
          return (
            <a
              href={`/${link}`}
              className="col-span-1 font-bold bg-green xl:text-black pt-8 px-4 mb-8 xl:mb-0"
              key={title}
            >
              {title && (
                <h3 className="uppercase text-xl lg:text-base xxl:text-xl mb-2">
                  {title}
                </h3>
              )}
              {icon && (
                <div className="text-center mb-4 xl:mb-6">
                  <EmojiIcon
                    animated
                    name={icon.emoji}
                    className="text-3xl text-center"
                  />
                </div>
              )}
              {price && (
                <WrapRotation rotationRange={"md"}>
                  <p className="uppercase bg-black text-white text-xl font-bold mb-8 p-2">
                    {price}
                  </p>
                </WrapRotation>
              )}
              {richText && (
                <span className="block align-left text-base font-normal netlife-sans">
                  <RenderRichContent content={richText} />
                </span>
              )}
              {text && (
                <p className="text-base font-normal netlife-sans">{text}</p>
              )}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default PriceComparison;
